document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY_OPEN_CART = 'pipeline_open_cart_after_reload';
  const STORAGE_KEY_SCROLL_Y = 'pipeline_scroll_y';

  // --- 1. Restore State (Scroll & Open) ---
  const savedScroll = sessionStorage.getItem(STORAGE_KEY_SCROLL_Y);
  if (savedScroll) {
    window.scrollTo(0, parseInt(savedScroll, 10));
    sessionStorage.removeItem(STORAGE_KEY_SCROLL_Y);
  }

  if (sessionStorage.getItem(STORAGE_KEY_OPEN_CART)) {
    sessionStorage.removeItem(STORAGE_KEY_OPEN_CART);
    // Correctly set the visibility of cart elements based on content
    updateDrawerUI();
    // Open the drawer
    openDrawer();
  }

  // --- 2. Add to Cart Interception (Force Reload) ---
  // A. Handle standard form submissions (e.g. PDP)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && form.action && form.action.includes('/cart/add')) {
      e.preventDefault();
      forceCartSubmit(form);
    }
  }, true);

  // B. Handle Click Events (Aggressive Capture for Grid/Listings)
  // This targets buttons often wrapped in broken HTML (<a> wrappers) or controlled by theme JS.
  document.addEventListener('click', (e) => {
    // Look for the add-to-cart button or input
    const btn = e.target.closest('[name="add"], [data-add-to-cart]');
    if (!btn) return;

    // Must be inside a form targeting the cart
    const form = btn.closest('form');
    if (!form || !form.action || !form.action.includes('/cart/add')) return;

    // Prevent any default behavior (like following the wrapping <a> link)
    // and stop propagation so theme listeners (e.g. drawer toggles) don't fire.
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    forceCartSubmit(form);
  }, true); // Capture phase is critical to run before theme/Alpine listeners

  // --- 3. Close Button (Capture Phase) ---
  // Intercept clicks on the close button to prevent conflict with theme.js
  document.addEventListener('click', (e) => {
    const drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer || !drawer.classList.contains('is-open')) return;

    // Check if clicked element is a close button or the overlay
    const closeBtn = e.target.closest('.drawer__close');
    const isOverlay = e.target.classList.contains('drawer') && !e.target.closest('.drawer__content');

    // Ensure the close button belongs to the cart drawer
    if (closeBtn && !drawer.contains(closeBtn)) return;

    if (closeBtn || isOverlay) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeDrawer();
    }
  }, true);


  // --- 4. Remove Item (Force Reload Strategy) ---
  // Intercept clicks on the remove button, force a POST submit with return_to
  document.addEventListener('click', (e) => {
    // Target the remove link/button inside the cart items
    const removeLink = e.target.closest('.cart__items__remove a, [data-remove-key]');
    if (!removeLink) return;

    // Ensure we are inside the drawer
    const drawer = removeLink.closest('[data-drawer="drawer-cart"]');
    if (!drawer) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const lineKey = removeLink.getAttribute('data-remove-key');
    let url = removeLink.href;

    // Create a form to submit
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = window.Shopify.routes.root + 'cart/change';
    form.style.display = 'none';

    // Input for quantity = 0
    const qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity';
    qtyInput.value = '0';
    form.appendChild(qtyInput);

    // Input for ID/Line
    // Format: /cart/change?line=1&quantity=0 or /cart/change?id=KEY&quantity=0
    if (lineKey) {
        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        idInput.value = lineKey;
        form.appendChild(idInput);
    } else if (url) {
        const urlObj = new URL(url, window.location.origin);
        const line = urlObj.searchParams.get('line');
        const id = urlObj.searchParams.get('id');

        if (id) {
            const idInput = document.createElement('input');
            idInput.type = 'hidden';
            idInput.name = 'id';
            idInput.value = id;
            form.appendChild(idInput);
        } else if (line) {
            const lineInput = document.createElement('input');
            lineInput.type = 'hidden';
            lineInput.name = 'line';
            lineInput.value = line;
            form.appendChild(lineInput);
        }
    }

    document.body.appendChild(form);

    // Use the shared forceCartSubmit to handle state saving and return_to
    forceCartSubmit(form);

  }, true);


  // --- Helper Functions ---

  function forceCartSubmit(form) {
    sessionStorage.setItem(STORAGE_KEY_SCROLL_Y, window.scrollY);
    sessionStorage.setItem(STORAGE_KEY_OPEN_CART, 'true');

    // Add return_to input to keep user on the same page
    let returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.appendChild(returnTo);
    }
    // Use pathname + search to keep query params (like filters)
    returnTo.value = window.location.pathname + window.location.search;

    form.submit();
  }

  function openDrawer() {
    const drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) return;

    // Use the theme drawer event so it initializes quantity listeners, etc.
    drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
  }

  function closeDrawer() {
    const drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) return;

    // Close through the theme event to mirror native behavior
    drawer.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
  }

  function updateDrawerUI() {
    const drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) return;

    // Locate the critical containers
    const emptyMsg = drawer.querySelector('[data-cart-empty]');
    const cartForm = drawer.querySelector('[data-cart-form]');
    const cartBottom = drawer.querySelector('[data-cart-bottom]');

    // Check for actual items using the class or attribute used in the snippet
    // snippets/cart-line-items.liquid uses [data-cart-item] for each row
    const cartItems = drawer.querySelectorAll('[data-cart-item]');
    const hasItems = cartItems.length > 0;

    if (hasItems) {
      // Cart has items: Hide empty message, show form and bottom
      if (emptyMsg) emptyMsg.classList.add('cart--hidden');
      if (cartForm) cartForm.classList.remove('cart--hidden');
      if (cartBottom) cartBottom.classList.remove('cart--hidden');
    } else {
      // Cart is empty: Show empty message, hide form and bottom
      if (emptyMsg) emptyMsg.classList.remove('cart--hidden');
      if (cartForm) cartForm.classList.add('cart--hidden');
      if (cartBottom) cartBottom.classList.add('cart--hidden');
    }
  }
});
